export const SALES_COVERY_EMAIL = 'mailto:sales@covery.ai';
export const SUPPORT_COVERY_EMAIL = 'support@covery.ai';
